<template>
  <div class="modal fade" @keyup.esc.prevent="closeModal(false)" tabindex="-1" id="priceCampaignModal" aria-labelledby="priceCampaignModalLabel">
    <div class="modal-dialog modal-lg">
      <div v-if="loaded" class="modal-content shadow-none">
        <loader />
      </div>
      <div v-else class="modal-content shadow-none">
        <div class="modal-header p-5">
          <h5 class="modal-title">{{ campaign.id ? 'Редактирование кампании' : 'Новая ценовая кампания' }}</h5>
          <div @click="closeModal(false)" class="btn btn-icon btn-sm btn-active-light-primary ms-2">
            <i class="ki-duotone ki-cross fs-2x"><span class="path1"></span><span class="path2"></span></i>
          </div>
        </div>
        <div class="modal-body p-5">
          <div class="row">
            <div class="col-md-12">
              <input-field
                v-model="campaign.price"
                id="campaign.price"
                name="campaign.price"
                placeholder="Акционная цена"
                type="number"
                mb="5"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-floating mb-5">
                <input
                  id="campaign.startDateTime"
                  v-model="startDateTimeInput"
                  class="form-control form-control-solid"
                  type="datetime-local"
                  autocomplete="off"
                >
                <label for="campaign.startDateTime">Дата и время начала (Ташкент)</label>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-floating mb-5">
                <input
                  id="campaign.endDateTime"
                  v-model="endDateTimeInput"
                  class="form-control form-control-solid"
                  type="datetime-local"
                  autocomplete="off"
                >
                <label for="campaign.endDateTime">Дата и время окончания (Ташкент)</label>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer p-5 justify-content-between">
          <button type="button" @click="closeModal(false)" class="btn btn-light btn-sm">Закрыть</button>
          <button type="button" @click="saveCampaign" :disabled="saving" class="btn btn-primary btn-sm">
            {{ saving ? 'Сохранение...' : 'Сохранить' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import InputField from '@/components/Fields/InputField'
import { notify } from '@kyvg/vue3-notification'
import axios from 'axios'

const API_BASE = '/api/admin/v1/price-campaigns'

const createDefaultCampaign = () => ({
  id: null,
  price: null,
  startDateTime: '',
  endDateTime: '',
  status: null,
})

export default {
  name: 'PriceCampaignModal',
  components: { Loader, InputField },
  props: {
    itemData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loaded: false,
      saving: false,
      campaign: createDefaultCampaign(),
      startDateTimeInput: '',
      endDateTimeInput: '',
    };
  },
  mounted() {
    this.hydrateCampaign();
    setTimeout(() => {
      const modalEl = document.getElementById('priceCampaignModal');
      if (modalEl) {
        modalEl.addEventListener('mousedown', (event) => {
          if (event.target.classList.contains('modal')) this.closeModal(false);
        });
      }
    }, 10);
  },
  methods: {
    getErrorMessage(err) {
      return err?.response?.data?.message
        ?? err?.response?.data?.errorDescription
        ?? err.message;
    },
    instantToDatetimeLocal(iso) {
      if (!iso) return '';
      const d = new Date(iso);
      if (Number.isNaN(d.getTime())) return '';
      const formatter = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Asia/Tashkent',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      });
      const parts = formatter.formatToParts(d);
      const get = (type) => parts.find((p) => p.type === type)?.value || '';
      return `${get('year')}-${get('month')}-${get('day')}T${get('hour')}:${get('minute')}`;
    },
    datetimeLocalToRequest(value) {
      if (!value || String(value).trim() === '') return null;
      const v = String(value).trim();
      if (v.length === 16) return `${v}:00`;
      if (v.length === 19) return v;
      return v;
    },
    hydrateCampaign() {
      const source = this.itemData || {};
      this.campaign = {
        ...createDefaultCampaign(),
        ...source,
      };
      this.startDateTimeInput = this.instantToDatetimeLocal(this.campaign.startDateTime);
      this.endDateTimeInput = this.instantToDatetimeLocal(this.campaign.endDateTime);
    },
    closeModal(isUpdate) {
      const modalInstance = bootstrap.Modal.getInstance(document.getElementById('priceCampaignModal'));
      if (modalInstance) modalInstance.hide();
      this.$emit('closeModal', isUpdate);
    },
    saveCampaign() {
      const price = Number(this.campaign.price);
      if (!price || price <= 0) {
        notify({
          duration: 7000,
          type: 'error',
          speed: 1000,
          title: 'Ошибка',
          text: 'Укажите цену больше 0',
        });
        return;
      }
      const startDateTime = this.datetimeLocalToRequest(this.startDateTimeInput);
      const endDateTime = this.datetimeLocalToRequest(this.endDateTimeInput);
      if (!startDateTime || !endDateTime) {
        notify({
          duration: 7000,
          type: 'error',
          speed: 1000,
          title: 'Ошибка',
          text: 'Заполните дату начала и окончания',
        });
        return;
      }
      if (new Date(endDateTime) <= new Date(startDateTime)) {
        notify({
          duration: 7000,
          type: 'error',
          speed: 1000,
          title: 'Ошибка',
          text: 'Дата окончания должна быть позже даты начала',
        });
        return;
      }

      this.saving = true;
      const payload = {
        price,
        startDateTime,
        endDateTime,
      };

      const request = this.campaign.id
        ? axios.put(`${API_BASE}/${this.campaign.id}`, payload)
        : axios.post(API_BASE, payload);

      request
        .then(() => {
          notify({
            duration: 7000,
            type: 'success',
            speed: 1000,
            title: 'Успешно',
            text: this.campaign.id ? 'Кампания обновлена' : 'Кампания создана',
          });
          this.closeModal(true);
        })
        .catch((err) => {
          notify({
            duration: 7000,
            type: 'error',
            speed: 1000,
            title: 'Ошибка',
            text: this.getErrorMessage(err),
          });
        })
        .finally(() => {
          this.saving = false;
        });
    },
  },
}
</script>

<style scoped>

</style>
